export default __webpack_public_path__ + "static/media/TF1-1.5bbd2cda.jpg";